<template>
  <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      right
      open-on-hover
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          v-on="on"
          v-bind="attrs"
          icon
          small
          color="primary"
          class="text-capitalize"
      >
        <v-icon>info</v-icon>
      </v-btn>
    </template>

    <v-card max-width="350px">
      <v-card-text>
        {{ $t('location.geoLocation.deviceNote') }}
        <ul>
          <li class="my-2">
            <span>
              <span class="text-decoration-underline">
                {{ `${capitalize($t('location.geoLocation.BORDERING_INSIDE'))}:` }}
              </span>
              <p v-html="$t('location.geoLocation.mayBeOutside')"></p>
            </span>
          </li>
          <li class="my-2">
            <span>
              <span class="text-decoration-underline">
                {{ `${capitalize($t('location.geoLocation.BORDERING_INSIDE'))}:` }}
              </span>
              <p v-html="$t('location.geoLocation.mayBeOutside')"></p>
            </span>
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'GeofenceResultInfoMenu',

  data() {
    return {
      menu: false,
    };
  },
};
</script>

<style scoped>

</style>
